const rankingItems = [
  {
    rank: 1,
    title: '海角视频创作指南 · 从入门到精通',
    category: '教程',
    hot: '9.8万热度',
    trend: 'up',
  },
  {
    rank: 2,
    title: '2026夏季热门原创作品大赏',
    category: '盘点',
    hot: '8.5万热度',
    trend: 'up',
  },
  {
    rank: 3,
    title: '社区最活跃话题：创作者收入模型探讨',
    category: '讨论',
    hot: '7.2万热度',
    trend: 'hot',
  },
  {
    rank: 4,
    title: '海角论坛深度长文：原创生态的未来',
    category: '深度',
    hot: '6.8万热度',
    trend: 'up',
  },
  {
    rank: 5,
    title: '海角社新功能内测：AI辅助创作工具',
    category: '资讯',
    hot: '6.1万热度',
    trend: 'new',
  },
];

const trendIcons: Record<string, string> = {
  up: 'ri-arrow-up-line',
  hot: 'ri-fire-line',
  new: 'ri-sparkling-line',
};

const trendColors: Record<string, string> = {
  up: 'text-primary-600',
  hot: 'text-accent-600',
  new: 'text-secondary-600',
};

export default function Ranking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热门榜单
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-md mx-auto">
            海角网人气内容实时排行
          </p>
        </div>

        <div className="max-w-2xl mx-auto bg-background-100 rounded-2xl border border-background-200/70 overflow-hidden">
          {rankingItems.map((item, i) => (
            <div
              key={item.rank}
              className={`flex items-center gap-4 px-5 py-4 cursor-pointer hover:bg-background-50 transition-colors ${
                i < rankingItems.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <div
                className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold flex-shrink-0 ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-200 text-foreground-600'
                }`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium text-foreground-900 truncate">
                  {item.title}
                </div>
                <div className="flex items-center gap-2 mt-0.5">
                  <span className="text-xs text-foreground-400">{item.category}</span>
                  <span className="text-xs text-foreground-400">{item.hot}</span>
                </div>
              </div>
              <div className="flex-shrink-0 flex items-center gap-1">
                <i className={`${trendIcons[item.trend]} ${trendColors[item.trend]} text-sm`}></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}